import * as Cesium from 'cesium';
import { elevateBridges } from './bridgeDetails';

/** OSMの車線数から推定した中心部の区画線。実測の道路LODではない。 */
export async function loadRoadDetails(viewer: Cesium.Viewer): Promise<Cesium.GeoJsonDataSource> {
  const data = await Cesium.GeoJsonDataSource.load('/data/tokushima-road-details.geojson', {
    clampToGround: true,
    credit: '© OpenStreetMap contributors',
  });
  const time = viewer.clock.currentTime;
  for (const entity of data.entities.values) {
    const kind = entity.properties?.getValue(time).kind;
    if (entity.polygon) {
      entity.polygon.material = new Cesium.ColorMaterialProperty(
        Cesium.Color.fromCssColorString(kind === 'bridge' ? '#4b5055' : '#363a3e').withAlpha(kind === 'bridge' ? 0.72 : 0.58),
      );
      entity.polygon.classificationType = new Cesium.ConstantProperty(Cesium.ClassificationType.TERRAIN);
      entity.polygon.outline = new Cesium.ConstantProperty(false);
      entity.polygon.zIndex = new Cesium.ConstantProperty(kind === 'bridge' ? 7 : 5);
    }
    if (!entity.polyline) continue;
    entity.polyline.clampToGround = new Cesium.ConstantProperty(true);
    entity.polyline.classificationType = new Cesium.ConstantProperty(Cesium.ClassificationType.TERRAIN);
    entity.polyline.width = new Cesium.ConstantProperty(kind === 'edge' ? 1.25 : 1.5);
    entity.polyline.distanceDisplayCondition = new Cesium.ConstantProperty(new Cesium.DistanceDisplayCondition(0, 1800));
    entity.polyline.material = kind === 'lane'
      ? new Cesium.PolylineDashMaterialProperty({ color: Cesium.Color.WHITE.withAlpha(0.8), dashLength: 24, dashPattern: 255 })
      : new Cesium.ColorMaterialProperty(Cesium.Color.WHITE.withAlpha(kind === 'center' ? 0.8 : 0.65));
    entity.name = `${entity.properties?.getValue(time).name || '道路'} / 区画線は車線属性からの推定`;
  }
  viewer.dataSources.add(data);
  void elevateBridges(viewer, data).catch(error => console.warn('[Bridge] 平面表示を継続', error));
  viewer.scene.requestRender();
  return data;
}
